import { Controller } from 'stimulus';
import OverlayScrollbars from 'overlayscrollbars';

export default class extends Controller {
  connect() { 
    OverlayScrollbars(this.element, { });
  }
}
